import { useInitialize, InitializePayload } from 'hooks';
import { LOADING_ELEMENT_ID, ROOT_ELEMENT_ID } from 'models';
import React, { useEffect } from 'react';
import {
  useCurrentPageState,
  CurrentPageState,
  CURRENT_PAGE_STATE_TYPE,
} from 'store';
import {
  Auth,
  Complete,
  Confirm,
  Error,
  Input,
  Maintenance,
  Private,
  ReceptionAuthenticationError,
} from './pages';

const hideLoadingAndShowApp = () => {
  const loadingEl = document.getElementById(LOADING_ELEMENT_ID);
  const rootEl = document.getElementById(ROOT_ELEMENT_ID);
  if (loadingEl) {
    loadingEl.style.display = 'none';
  }
  if (rootEl) {
    rootEl.style.display = '';
  }
};

const getPage = (currentPageState: CurrentPageState) => {
  const {
    loading,
    error,
    maintenance,
    input,
    confirm,
    complete,
    authentication,
    receptionAuthenticationError,
  } = CURRENT_PAGE_STATE_TYPE;
  if (currentPageState.type === loading) {
    return null;
  } else {
    hideLoadingAndShowApp();
  }
  switch (currentPageState.type) {
    case error: {
      const { title, japanese, english } = currentPageState.error;
      return <Error title={title} japanese={japanese} english={english} />;
    }
    case maintenance: {
      const { title, japanese, english, japaneseTerm, englishTerm } =
        currentPageState.error;
      return (
        <Maintenance
          title={title}
          japanese={japanese}
          english={english}
          japaneseTerm={japaneseTerm}
          englishTerm={englishTerm}
        />
      );
    }
    case authentication:
      return <Auth />;
    case input:
      return <Input />;
    case confirm:
      return <Confirm />;
    case complete:
      return <Complete />;
    case receptionAuthenticationError:
      return <ReceptionAuthenticationError />;
    case CURRENT_PAGE_STATE_TYPE.private:
      return <Private />;
  }
};

export type AppProps = InitializePayload;

export const App: React.FC<AppProps> = (props: AppProps) => {
  const { initialize } = useInitialize();
  const currentPageState = useCurrentPageState();
  useEffect(() => {
    initialize(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return getPage(currentPageState);
};
